import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faPencil,
    faMoneyBill,
    faPerson,
    faUniversity,
    faAdd,
    faComment,
    faCoins, faMailReply, faHome, faLanguage, faBars, faScaleBalanced, faMailBulk, faFileCode
} from '@fortawesome/free-solid-svg-icons';
import {faAndroid} from "@fortawesome/free-brands-svg-icons";

const AdminMenu = ({path}) => {
    const menuItems = [
        { path: '/admin/', icon: faHome, text: 'خانه' },
        { path: '/admin/blog', icon: faBook, text: 'مقاله‌ها' },
        { path: '/admin/blog/new-post', icon: faPencil, text: 'مقاله‌ی جدید' },
        { path: '/admin/course', icon: faUniversity, text: 'دوره‌ها' },
        { path: '/admin/course/new/overview', icon: faAdd, text: 'دوره‌ی جدید' },
        { path: '/admin/cheatsheet', icon: faFileCode, text: 'تقلب‌نامه' },
        { path: '/admin/glossary', icon: faBook, text: 'دیکشنری' },
        { path: '/admin/purchase', icon: faCoins, text: 'خرید‌ها' },
        { path: '/admin/mail/', icon: faMailBulk, text: 'ارسال ایمیل' },
        { path: '/admin/categories/', icon: faBars, text: 'دسته‌بندی' },
        { path: '/admin/language/', icon: faLanguage, text: 'زبان‌ها' },
        { path: '/admin/updates/', icon: faAndroid, text: 'نسخه‌ها' },
        { path: '/admin/rules/', icon: faScaleBalanced, text: 'قوانین' },
    ];

    return (
        <div className='m-5 relative text-black bg-gray-100 rounded-md'>
            <ul className='flex-col'>
                {menuItems.map((item, index) => (
                    <li
                        key={index}
                        className='w-full flex items-center last:rounded-b-md first:rounded-t-md cursor-pointer hover:bg-light-light hover:text-light-primary transition-colors'
                    >
                        <Link to={item.path} className='w-full px-6 py-5'>
                            <FontAwesomeIcon icon={item.icon} size={"xl"} className='ml-5' />
                            <span className={'text-lg font-bold'}>{item.text}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminMenu;
